

const FilterBox = ({ filters, updateFilters }) => {
    const onFilter = (event) => {
        const {
            target: { value, checked }
        } = event;

        /*
        updateFilters(
            filters.map((f) => {
            if (f.label === value) {
                return {
                ...f,
                isChecked: checked
                };
            }
            return f;
            })
        );
        */
        updateFilters(
            filters.map((f) => {
                return {
                    ...f,
                    isChecked: value === "all" ? true : f.label === value
                };
            })
        );
    };

    return (
        <div className="filter-box">
            {filters.map((item) => (
                <div className="filter-box-item d-inline-block" key={`${item.label}_key`}>
                    <input
                        id={item.label}
                        type="checkbox"
                        value={item.label}
                        onChange={onFilter}
                        checked={item.isChecked}
                    />
                    <label htmlFor={item.label}>{item.label}</label>
                </div>
            ))}
        </div>
    );
};
export default FilterBox;
